import React, { useState } from 'react';
const faqs = [{
  q: 'È adatto anche a personal trainer beginners?',
  a: 'Sì. Il sistema include progressioni e strutture facili da seguire.'
}, {
  q: 'Posso usarlo in small group?',
  a: 'Assolutamente sì. È progettato anche per classi di gruppo.'
}, {
  q: 'Ricevo subito tutti i bonus?',
  a: "Sì. Ricevi accesso immediato all'intero sistema."
}, {
  q: 'Posso usarlo da tablet o smartphone?',
  a: 'Sì. È ottimizzato per tutti i dispositivi.'
}, {
  q: 'È un pagamento unico?',
  a: 'Sì. Nessun abbonamento mensile.'
}, {
  q: 'È adatto anche per women functional?',
  a: 'Sì. Include un intero volume dedicato.'
}, {
  q: 'È prevista una garanzia?',
  a: 'Sì. Hai 7 giorni di garanzia totale.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-bg-dark py-24 px-4 border-t border-border-light" data-id="element-126">
      <div className="max-w-3xl mx-auto" data-id="element-127">
        <h2 className="font-display text-3xl sm:text-5xl font-bold text-white text-center mb-12 tracking-tight uppercase" data-id="element-128">
          Domande Frequenti
        </h2>

        <div className="space-y-3 mb-16" data-id="element-129">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-sm overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_0_20px_rgba(242,92,37,0.15)]' : 'border-border-light hover:border-border-strong'}`} data-id="element-130">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-131">
                  <span className={`font-display font-bold text-base sm:text-lg uppercase tracking-wide transition-colors ${isOpen ? 'text-primary' : 'text-white'}`} data-id="element-132">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 font-bold ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-133">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-72 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-134">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-135">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center relative" data-id="element-136">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-cta-green/20 blur-[80px] pointer-events-none rounded-full" aria-hidden="true" data-id="element-137"></div>
          <a href="#pricing" onClick={() => {
          const w = window as any;
          if (w.fbq) {
            w.fbq('track', 'AddToCart', {
              content_name: 'Functional Pronto — Sistema Completo',
              content_type: 'product',
              value: 19,
              currency: 'EUR'
            });
          }
        }} className="relative btn-primary-pulse bg-cta-green font-display font-bold text-base sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-sm hover:bg-cta-green-hover transition-all inline-block mb-4 w-full sm:w-auto max-w-2xl text-white shadow-[0_0_30px_rgba(22,163,74,0.3)] border border-white/10 uppercase tracking-wide" data-id="element-138">
            🚀 SÌ! VOGLIO SMETTERE DI IMPROVVISARE LE MIE CLASSI
          </a>
          <p className="text-text-sec text-sm font-medium flex items-center justify-center gap-2 mt-3 uppercase tracking-wider flex-wrap" data-id="element-139">
            <span data-id="element-140">⚡ Accesso Immediato</span>
            <span data-id="element-141">•</span>
            <span data-id="element-142">🛡️ Garanzia 7 Giorni</span>
            <span data-id="element-143">•</span>
            <span data-id="element-144">💳 Pagamento Sicuro</span>
          </p>
        </div>
      </div>
    </section>;
}